export default __webpack_public_path__ + "static/media/linepoints.2768b2a2.svg";